import { prop } from '@lib/style/theme';
import { unitStrict } from '@lib/style/unit';
import Paper, { PaperProps } from '@material-ui/core/Paper/Paper';
import { createMemo } from '@packages/react';
import React from 'react';
import styled from 'styled-components';

interface StyledPaperProps extends PaperProps {
    marginTop?: string | number;
    marginRight?: string | number;
    marginBottom?: string | number;
    marginLeft?: string | number;
    padding?: string | number;
}

const StyledPaper = createMemo<StyledPaperProps>(
    ({ marginTop, marginRight, marginBottom, marginLeft, padding, ...rest }) => <Paper {...rest} />,
    {
        displayName: 'StyledPaper',
        defaultProps: {
            elevation: 0,
            square: true,
        },
    },
);

/**
 * @author: Stefan Binder <stefan.binder89@gmail.com>
 * @class: Icon
 * @date:  29.08.2018
 * @time:  10:14
 * @scope:
 */
export const SPaper = styled(StyledPaper)<StyledPaperProps>`
    && {
        width: 100%;
        margin-top: ${prop('marginTop', 28, unitStrict)};
        margin-right: ${prop('marginRight', 0, unitStrict)};
        margin-bottom: ${prop('marginBottom', 0, unitStrict)};
        margin-left: ${prop('marginLeft', 0, unitStrict)};
        padding: ${prop('padding', '0 0 14px 0', unitStrict)};
    }
`;
